export const ACTION_LOGIN = 'actionLogin';
export const ACTION_LOGOUT = 'actionLogout';
export const ACTION_REFRESH_TOKEN = 'actionRefreshToken';
export const ACTION_GO_LOGIN = 'actionGoLogin';
export const ACTION_SAVE_AUTH_USER = 'actionSaveAuthUser';
